"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMOE_EMAIL_BIZ_TYPE = void 0;
/**
 * AMOE 邮件模板业务类型。
 *
 * 仅承担"业务场景"枚举,不再承担模板 ID 维护;
 * - tplId 走 `metsConfig.amoeMail.*`,由 FCC 注入,与 SMS verify 同口径;
 * - appid / appkey 与 SMS 共用 `metsConfig.amoeSms`,不在此处重复声明。
 */
exports.AMOE_EMAIL_BIZ_TYPE = {
    /** AMOE 用户中奖后通知 */
    PRIZE_WIN: 'prize_win',
    /** AMOE 奖励继承成功后通知 */
    INHERIT_NOTIFY: 'inherit_notify',
};
